"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.STRATEGY_VAULTS = exports.STAKE_VAULTS = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
const tokens_1 = require("./tokens");
const nullAddr = anchor.web3.SYSVAR_RENT_PUBKEY;
const testingInProdStakingVault = {
    name: "TESTING",
    lp: tokens_1.LP_TOKENS["TEST_LPTOKEN2"],
    tokenInput: "TESTING",
    reward: tokens_1.TOKENS.TEST1,
    rewardB: tokens_1.TOKENS.TEST2,
    tvl: "0.00",
    risk: "Low",
    dailyApy: "0.00",
    yearlyApy: "0.00",
    programId: nullAddr,
    poolId: nullAddr,
    poolAuthority: nullAddr,
    poolLpTokenAccount: nullAddr,
    poolRewardTokenAccount: nullAddr,
    poolRewardTokenAccountB: nullAddr,
    vaultAccount: nullAddr,
    vaultSigner: nullAddr,
    vaultLpTokenMintAddress: nullAddr,
    vaultUserInfoAccount: nullAddr,
    vaultLpTokenAccount: nullAddr,
    vaultInputTokenAccount: nullAddr,
    protocolsTxt: "",
    risksTxt: "- This project is not audited",
};
exports.STAKE_VAULTS = [testingInProdStakingVault];
// Invest Vaults
const solanaStrategyBestAPY = {
    type: "bestApy",
    name: "Best APY",
    input: tokens_1.TOKENS.WSOL,
    lp: tokens_1.TOKENS.ggSOL,
    vaultAccount: new anchor.web3.PublicKey("CNJrJumoPRxvCaQZ2MJTEUUitwwen955JsxiUvoJa7Wp"),
    tvl: new anchor.BN(0),
    supply: new anchor.BN(0),
    apy: "0",
    apr: "0",
    aboutTxt: "This strategy automatically rebalances between different lending protocols in order to get the maximum yield in each period.",
    protocolsTxt: "Mango, Port, Tulip, Solend and Francium",
    risksTxt: "The protocols being used underneath (although being audited) present some risks. No audit has been done for the current strategy. Use it at your own risk.",
};
const usdcStrategyBestAPY = {
    type: "bestApy",
    name: "Best APY",
    input: tokens_1.TOKENS.USDC,
    lp: tokens_1.TOKENS.ggUSDC,
    vaultAccount: new anchor.web3.PublicKey("ATJpBsXbhio5c5kqgMHmAfFDdjsS3ncZmZyZzNY87XqZ"),
    tvl: new anchor.BN(0),
    supply: new anchor.BN(0),
    apy: "0",
    apr: "0",
    aboutTxt: "This strategy automatically rebalances between different lending protocols in order to get the maximum yield in each period.",
    protocolsTxt: "Mango, Port, Tulip, Solend and Francium",
    risksTxt: "The protocols being used underneath (although being audited) present some risks. No audit has been done for the current strategy. Use it at your own risk.",
};
const msolStrategyBestAPY = {
    type: "bestApy",
    name: "Best APY",
    input: tokens_1.TOKENS.mSOL,
    lp: tokens_1.TOKENS.ggmSOL,
    vaultAccount: new anchor.web3.PublicKey("7reMieMkh3MCJXQqmnv9xhCBcy3B5qaGbhf6HC8kZFyc"),
    tvl: new anchor.BN(0),
    supply: new anchor.BN(0),
    apy: "0",
    apr: "0",
    aboutTxt: "This strategy automatically rebalances between different lending protocols in order to get the maximum yield in each period.",
    protocolsTxt: "Mango, Port, Tulip, Solend and Francium",
    risksTxt: "The protocols being used underneath (although being audited) present some risks. No audit has been done for the current strategy. Use it at your own risk.",
};
const usdtStrategyBestAPY = {
    type: "bestApy",
    name: "Best APY",
    input: tokens_1.TOKENS.USDT,
    lp: tokens_1.TOKENS.ggUSDT,
    vaultAccount: new anchor.web3.PublicKey("ATpgW6RzUvEt13rU9NMj1HsmEeW2zC9a1k5AQbako8md"),
    tvl: new anchor.BN(0),
    supply: new anchor.BN(0),
    apy: "0",
    apr: "0",
    aboutTxt: "This strategy automatically rebalances between different lending protocols in order to get the maximum yield in each period.",
    protocolsTxt: "Mango, Port, Tulip, Solend and Francium",
    risksTxt: "The protocols being used underneath (although being audited) present some risks. No audit has been done for the current strategy. Use it at your own risk.",
};
const btcStrategyBestAPY = {
    type: "bestApy",
    name: "Best APY",
    input: tokens_1.TOKENS.BTC,
    lp: tokens_1.TOKENS.ggBTC,
    vaultAccount: new anchor.web3.PublicKey("FvqYV2Cg7s7iWKUBTWkyybKuz1m85ny6ijDqDXEXVyNv"),
    tvl: new anchor.BN(0),
    supply: new anchor.BN(0),
    apy: "0",
    apr: "0",
    aboutTxt: "This strategy automatically rebalances between different lending protocols in order to get the maximum yield in each period.",
    protocolsTxt: "Mango, Port, Tulip, Solend and Francium",
    risksTxt: "The protocols being used underneath (although being audited) present some risks. No audit has been done for the current strategy. Use it at your own risk.",
};
const soEthStrategyBestAPY = {
    type: "bestApy",
    name: "Best APY",
    input: tokens_1.TOKENS.soETH,
    lp: tokens_1.TOKENS.ggsoETH,
    vaultAccount: new anchor.web3.PublicKey("B7TjXfMHG6sun7KdGFb4sWVCKikTKuaYitbosKc37vVf"),
    tvl: new anchor.BN(0),
    supply: new anchor.BN(0),
    apy: "0",
    apr: "0",
    aboutTxt: "This strategy automatically rebalances between different lending protocols in order to get the maximum yield in each period.",
    protocolsTxt: "Mango, Tulip, Solend and Francium",
    risksTxt: "The protocols being used underneath (although being audited) present some risks. No audit has been done for the current strategy. Use it at your own risk.",
};
const stSOLStrategyBestAPY = {
    type: "bestApy",
    name: "Best APY",
    input: tokens_1.TOKENS.stSOL,
    lp: tokens_1.TOKENS.ggstSOL,
    vaultAccount: new anchor.web3.PublicKey("47hnvWxWo4PpPNqPF78cJ4abjpT45qY9of8hokeLzEUX"),
    tvl: new anchor.BN(0),
    supply: new anchor.BN(0),
    apy: "0",
    apr: "0",
    aboutTxt: "This strategy automatically rebalances between different lending protocols in order to get the maximum yield in each period.",
    protocolsTxt: "Port, Tulip, Solend and Francium",
    risksTxt: "The protocols being used underneath (although being audited) present some risks. No audit has been done for the current strategy. Use it at your own risk.",
};
const srmStrategyBestAPY = {
    type: "bestApy",
    name: "Best APY",
    input: tokens_1.TOKENS.SRM,
    lp: tokens_1.TOKENS.ggSRM,
    vaultAccount: new anchor.web3.PublicKey("3MvY3Tk3PmQhEeHqyfJA9gDBq83MUM92rgbhLeY27JLv"),
    tvl: new anchor.BN(0),
    supply: new anchor.BN(0),
    apy: "0",
    apr: "0",
    aboutTxt: "This strategy automatically rebalances between different lending protocols in order to get the maximum yield in each period.",
    protocolsTxt: "Port, Tulip, Solend and Francium",
    risksTxt: "The protocols being used underneath (although being audited) present some risks. No audit has been done for the current strategy. Use it at your own risk.",
};
const mngoStrategyBestAPY = {
    type: "bestApy",
    name: "Best APY",
    input: tokens_1.TOKENS.MNGO,
    lp: tokens_1.TOKENS.ggMNGO,
    vaultAccount: new anchor.web3.PublicKey("E5znWeT1pEiMXpko8JUNvGfs1X6cuupHZB2PeDhx5mt8"),
    tvl: new anchor.BN(0),
    supply: new anchor.BN(0),
    apy: "0",
    apr: "0",
    aboutTxt: "This strategy automatically rebalances between different lending protocols in order to get the maximum yield in each period.",
    protocolsTxt: "Mango",
    risksTxt: "The protocols being used underneath (although being audited) present some risks. No audit has been done for the current strategy. Use it at your own risk.",
};
const rayStrategyBestAPY = {
    type: "bestApy",
    name: "Best APY",
    input: tokens_1.TOKENS.RAY,
    lp: tokens_1.TOKENS.ggRAY,
    vaultAccount: new anchor.web3.PublicKey("6w6NRsDUnBieNiVBHoixEqqfGnr2wXdoSWWZRn7S36db"),
    tvl: new anchor.BN(0),
    supply: new anchor.BN(0),
    apy: "0",
    apr: "0",
    aboutTxt: "This strategy automatically rebalances between different lending protocols in order to get the maximum yield in each period.",
    protocolsTxt: "Mango, Tulip, Solend and Francium",
    risksTxt: "The protocols being used underneath (although being audited) present some risks. No audit has been done for the current strategy. Use it at your own risk.",
};
const orcaStrategyBestAPY = {
    type: "bestApy",
    name: "Best APY",
    input: tokens_1.TOKENS.ORCA,
    lp: tokens_1.TOKENS.ggORCA,
    vaultAccount: new anchor.web3.PublicKey("9b2J1JjsvnkLc9ZQmARDbq7EMhCDzr4QG4fAR6TfZkTK"),
    tvl: new anchor.BN(0),
    supply: new anchor.BN(0),
    apy: "0",
    apr: "0",
    aboutTxt: "This strategy automatically rebalances between different lending protocols in order to get the maximum yield in each period.",
    protocolsTxt: "Tulip, Solend and Francium",
    risksTxt: "The protocols being used underneath (although being audited) present some risks. No audit has been done for the current strategy. Use it at your own risk.",
};
exports.STRATEGY_VAULTS = [
    solanaStrategyBestAPY,
    usdcStrategyBestAPY,
    msolStrategyBestAPY,
    usdtStrategyBestAPY,
    btcStrategyBestAPY,
    soEthStrategyBestAPY,
    stSOLStrategyBestAPY,
    srmStrategyBestAPY,
    mngoStrategyBestAPY,
    rayStrategyBestAPY,
    orcaStrategyBestAPY,
];
//# sourceMappingURL=vaults.js.map